import React, { Component } from "react";
import "../../css/salesstats.css";
import { Button, Table, ToggleButtonGroup, ToggleButton} from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import ReactChartkick, { PieChart } from 'react-chartkick';
import Chart from 'chart.js';
import { ReportService } from "../../Services/ReportService";
import { toInt, format_date_only } from "../../Utils";
import { Paper } from "@material-ui/core";

ReactChartkick.addAdapter(Chart)

export default class SalesStats extends Component {

    constructor(props) {
      super(props);
      this.state = {
        data: [],
        rows: [],
        startDate: moment().subtract(7, "days"),
        endDate: moment(),
        message : "",
        filter: 1
      }
      this.handleChangeStart = this.handleChangeStart.bind(this);
      this.handleChangeEnd = this.handleChangeEnd.bind(this);
      this.handlChange = this.handlChange.bind(this);
    }
    
 
    componentDidMount(){
        this.props.setTitle('Product Trends');
        this.fetchData();
    }

    fetchData(){
        let rows = [];
        this.props.isLoading(true);
        ReportService.getReportSalesStats(this.state.startDate, this.state.endDate, this.state.filter)
        .then((data) => {
            let dataIn = [];
            let d = data.report.sort(function(a, b) {
                return parseInt(b.total_qty, 10) - parseInt(a.total_qty, 10);
            });
            d.forEach(element => {
                    dataIn.push([element.product_name, element.total_qty])
                    rows.push(<ReportDetails key={element.product_name} report={element}/>);
            });
            this.setState({data: dataIn, rows: rows})
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    handleChangeStart(date){
        this.setState({
            startDate: date
        });
    }

    handleChangeEnd(date){
        this.setState({
            endDate: date
        });
    }

    handlChange(e){
        this.setState({filter: toInt(e.target.value)});
    }
    
    render() {
        const message = this.state.message;
        return (
            <div className="Home sales-stats" style={{marginTop: 32}}>
                <Paper style={{paddingTop: 16, paddingBottom: 16}}>
                    <div className="rangeContainer">
                    <div className="centerwrapper">
                        <div className = "squareLabel marginRight">From</div>
                        <div className = "square">
                            <DatePicker
                                selected={this.state.startDate}
                                selectsStart
                                dateFormat={format_date_only}
                                startDate={this.state.startDate}
                                endDate={this.state.endDate}
                                onChange={this.handleChangeStart} />
                        </div>
                        <div className = "squareLabel">To</div>
                        <div className = "square">
                            <DatePicker
                                selected={this.state.endDate}
                                selectsEnd
                                startDate={this.state.startDate}
                                endDate={this.state.endDate}
                                dateFormat={format_date_only}
                                onChange={this.handleChangeEnd}
                            />
                        </div>
                        <div className = "square-radio">
                            <ToggleButtonGroup type="radio" name="options" defaultValue={this.state.filter}>
                                <ToggleButton value={1} onChange={(e)=>this.handlChange(e)}>All</ToggleButton>
                                <ToggleButton disabled={!this.props.modules_enabled.b2c_module} value={2} onChange={(e)=>this.handlChange(e)}>Customers</ToggleButton>
                                <ToggleButton disabled={!this.props.modules_enabled.b2b_module} value={3} onChange={(e)=>this.handlChange(e)}>Stores</ToggleButton>
                            </ToggleButtonGroup>
                        </div>
                        <div className = "square">
                            <Button onClick={(e) => { this.fetchData(e)}}>REFRESH</Button>
                        </div>
                    </div>
                    </div>
                </Paper>
                { !this.props.loading &&
                    <Paper style={{marginTop: 16, paddingTop: 16, paddingBottom: 16}}>
                        <PieChart legend={false} donut={true} data={this.state.data} />
                        <Table striped condensed hover responsive style={{margin: 8, width: '99%'}}>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Actual Requirement</th>
                                </tr>
                            </thead>
                            <tbody style={{textAlign: "left"}}>
                                {this.state.rows}
                            </tbody>
                        </Table>
                        {
                            message && 
                            (
                                <p style={{color:"red", paddingLeft:"20px"}}>{message}</p>
                            )
                        }
                    </Paper>
                }
            </div>
        );
    }

}

class ReportDetails extends Component {

    render(){
        const report = this.props.report;
        return (
            <tr>
                <td>{report.product_name}</td>
                <td>{report.total_qty}</td>
            </tr>
        );
    }
}